<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <h5 v-if="branch" class="m-0">
                  {{ branch.name }}
                </h5>
                <h6 v-if="branch" class="font-weight-bold">
                  {{ branch.code }}
                </h6>
              </div>
              <div class="col-auto">
                <button @click="print" class="btn btn-info">
                  <i class="lni lni-printer"></i> Print
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr />
                <div class="row">
                  <div class="col-md-4">
                    <label for="from">From</label>
                    <b-form-datepicker
                      id="from"
                      v-model="from"
                      class="mb-2"
                    ></b-form-datepicker>
                  </div>
                  <div class="col-md-4">
                    <label for="to">To</label>
                    <b-form-datepicker
                      id="to"
                      v-model="to"
                      class="mb-2"
                    ></b-form-datepicker>
                  </div>
                  <div class="col-md-4 d-flex">
                    <button
                      @click="getData"
                      class="btn btn-primary mt-auto mb-2"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body pt-2">
            <button class="btn btn-outline-primary">
              BF: <strong>{{ bf }}</strong>
            </button>
            <button class="btn btn-outline-primary">
              CL: <strong>{{ closing }}</strong>
            </button>
            <button
              class="btn float-right"
              :class="{
                'btn-info': order == 'asc',
                'btn-outline-info': order != 'asc',
              }"
              @click="sort('asc')"
            >
              <i class="lni lni-arrow-up"></i>
            </button>
            <button
              class="btn float-right"
              :class="{
                'btn-info': order == 'desc',
                'btn-outline-info': order != 'desc',
              }"
              @click="sort('desc')"
            >
              <i class="lni lni-arrow-down"></i>
            </button>

            <div class="table-responsive">
              <table class="table table-sm mt-2">
                <thead>
                  <tr class="bg-light">
                    <th>Date</th>
                    <th>#</th>
                    <th>Type</th>
                    <th>INV #</th>
                    <th>GKN</th>
                     <th>Detail</th>
                    <th>Supplier</th>
                    <th>In</th>
                    <th>Out</th>

                    <th class="text-right">Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="b in balanceSheet" :key="b.id">
                    <td>
                      {{
                        moment(new Date(b.created_at)).format(
                          "DD MMM YY, HH:mm"
                        )
                      }}
                    </td>
                    <td>
                      <span v-if="b.pallet_adjustment">
                        <button
                          class="btn btn-link m-0 p-0"
                          @click="
                            printAdjustment(
                              b.pallet_adjustment.id,
                              b.pallet_adjustment.pallet_adjustment_number
                            )
                          "
                        >
                          <strong>
                            <u>{{
                              b.pallet_adjustment.pallet_adjustment_number
                            }}</u></strong
                          >
                        </button>
                      </span>
                      <span v-if="b.pallet_movement">
                        <button
                          class="btn btn-link m-0 p-0"
                          @click="
                            printMovement(
                              b.pallet_movement.id,
                              b.pallet_movement.pallet_movement_number
                            )
                          "
                        >
                          <strong>
                            <u>
                              {{ b.pallet_movement.pallet_movement_number }}
                            </u></strong
                          >
                        </button>
                      </span>
                    </td>
                    <td>
                      <span v-if="b.pallet_adjustment">Adjustment</span>
                      <span v-if="b.pallet_movement">{{
                        b.pallet_movement.type
                      }}</span>
                    </td>
                    <td>  <span v-if="b.pallet_movement " > {{ b.pallet_movement.invoice_number }} </span></td>
                    <td>  <span v-if="b.pallet_movement " > {{ b.pallet_movement.gkn_number }} </span></td>
                    <td>
                      <span v-if="b.pallet_adjustment " >
                        {{ b.pallet_adjustment.remark }}
                      </span>
                         <span v-if="b.pallet_movement " >
                        {{ b.pallet_movement.remark }}
                      </span>



                      <span
                        v-if="
                          b.pallet_movement &&
                          b.pallet_movement.type == 'Inter branch transfer'
                        "
                      >
                        {{ b.pallet_movement.from_branch.code }}   <i class="lni lni-arrow-right mx-1"></i> {{ b.pallet_movement.to_branch.code }}
                      </span>



                    </td>
                    <td>
                      <span
                        v-if="
                          b.pallet_movement &&
                          b.pallet_movement.to_supplier != null
                        "
                      >
                        {{ b.pallet_movement.to_supplier.name }}
                      </span>
                      <span
                        v-if="
                          b.pallet_movement &&
                          b.pallet_movement.from_supplier != null
                        "
                      >
                        {{ b.pallet_movement.from_supplier.name }}
                      </span>
                    </td>
                    <td class="text-warning">{{ b.credit }}</td>
                    <td class="text-info">{{ b.debit }}</td>

                    <td class="font-weight-bold text-right">
                      {{ b.branch_balance }}
                    </td>
                  </tr>
                  <tr class="bg-light">
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th class="text-warning">{{ inTotal }}</th>
                    <th class="text-info">{{ outTotal }}</th>
                    <th></th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import palletRepo from "@/api/repos/palletRepo";

export default {
  props: ["id"],

  mounted() {
    this.getData();
  },

  data() {
    return {
      from: this.moment().startOf("month").format("YYYY-MM-DD"),
      to: this.moment().format("YYYY-MM-DD"),
      branch: null,
      balanceSheet: [],
      loading: false,
      errors: null,
      submitStatus: null,
      bf: 0,
      closing: 0,
      order: "desc",
      inTotal: 0,
      outTotal: 0,
    };
  },

  methods: {
    async getData() {
      if (!this.checkRange()) {
        return false;
      }

      this.order = "desc";
      this.inTotal = 0;
      this.outTotal = 0;

      try {
        let { data } = await palletRepo.balanceSheetBranchTransactions(
          this.from,
          this.to,
          this.id
        );
        this.branch = data.branch;
        this.balanceSheet = data.balance_sheet;
        if (this.balanceSheet.length > 0) {
          this.closing = this.balanceSheet[0].branch_balance;
          if (this.balanceSheet[this.balanceSheet.length - 1].debit != null) {
            this.bf =
              this.balanceSheet[this.balanceSheet.length - 1].branch_balance +
              this.balanceSheet[this.balanceSheet.length - 1].debit;
          } else {
            this.bf =
              this.balanceSheet[this.balanceSheet.length - 1].branch_balance -
              this.balanceSheet[this.balanceSheet.length - 1].credit;
          }
        }
        this.balanceSheet.forEach((x) => {
          if (x.debit != null) {
            this.outTotal += x.debit;
          } else {
            this.inTotal += x.credit;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    sort(order) {
      this.order = order;

      if (order == "asc") {
        this.balanceSheet.sort((a, b) => {
          if (a.id > b.id) return 1;
          if (a.id < b.id) return -1;
          return 0;
        });
      } else {
        this.balanceSheet.sort((a, b) => {
          if (a.id < b.id) return 1;
          if (a.id > b.id) return -1;
          return 0;
        });
      }
    },

    async print() {
      if (!this.checkRange()) {
        return false;
      }

      this.loading = true;

      try {
        let response = await palletRepo.balanceSheetBranchTransactionsPrint(
          this.from,
          this.to,
          this.id
        );
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `pallet_branch_balance_sheet.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async printMovement(id, number) {
      this.loading = true;

      try {
        let response = await palletRepo.movementPrint(id);
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `pallet_movement_${number}.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async printAdjustment(id, number) {
      this.loading = true;

      try {
        let response = await palletRepo.adjustmentPrint(id);
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `pallet_adjustment_${number}.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    checkRange() {
      //from is not greate
      if (this.moment(this.from).isAfter(this.moment(this.to))) {
        this.$root.$bvToast.toast("From can not be after to", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }

      //not more then a year
      if (this.moment(this.to).diff(this.moment(this.from), "days") > 366) {
        this.$root.$bvToast.toast("Range can not be greater than 1 year", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }

      return true;
    },
  },
};
</script>

